import React from "react";
import { staffTitles } from "@/lib/staffTitles";

export default function PrintSignatures({ counselorName, principalName, counselorGender, principalGender, className = "" }) {
  return (
    <div className={`print-signatures ${className}`} dir="ltr" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "24px", direction: "ltr", breakInside: "avoid" }}>
      <div data-signature="principal" dir="rtl" style={{ gridColumn: 1, gridRow: 1, textAlign: "center", borderTop: "1px solid #777", paddingTop: "8px" }}>{staffTitles(principalGender || counselorGender).principal}<br /><strong>{principalName || "—"}</strong><div>التوقيع: …………………</div></div>
      <div data-signature="counselor" dir="rtl" style={{ gridColumn: 2, gridRow: 1, textAlign: "center", borderTop: "1px solid #777", paddingTop: "8px" }}>{staffTitles(counselorGender).counselor}<br /><strong>{counselorName || "—"}</strong><div>التوقيع: …………………</div></div>
    </div>
  );
}
